import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ceramicCoatingPrices } from '../mockData';
import WhatsAppCTA from '../components/WhatsAppCTA';

const CeramicCoating = () => {
  return (
    <div className="min-h-screen bg-black py-16 px-4">
      <Helmet>
        <title>Ceramic Coating Tralee | From €200 | 7 Year Protection | Kingdom Auto Detailing</title>
        <meta name="description" content="Best ceramic coating near Tralee from €200. Professional car paint protection lasting 6 months to 7+ years. Hydrophobic, UV resistant, self-cleaning coating. Serving Tralee, Listowel, Ardfert. Book now!" />
        <meta name="keywords" content="ceramic coating Tralee, ceramic coating near Tralee, car paint protection Tralee, hydrophobic coating Tralee, ceramic coating cost Tralee, best ceramic coating Tralee Kerry, car coating Tralee, paint protection Tralee, graphene coating Tralee" />
        <link rel="canonical" href="https://kingdomautodetailing.ie/ceramic-coating" />
      </Helmet>

      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 text-center">
          Ceramic Coating Tralee
        </h1>
        <p className="text-xl text-gray-400 text-center mb-12 max-w-3xl mx-auto">
          Professional ceramic coating protection from €200 - lasting up to 7+ years. Serving Tralee, Listowel, Ardfert and all of North Kerry.
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-8 hover:scale-105 transition-transform duration-300">
            <h2 className="text-3xl font-bold text-white mb-6">What is Ceramic Coating?</h2>
            <p className="text-blue-100 leading-relaxed mb-4">
              Ceramic coating is a liquid polymer that chemically bonds with your vehicle's paint, creating a permanent 
              or semi-permanent layer of protection. Unlike traditional waxes or sealants, ceramic coatings provide superior 
              durability and protection.
            </p>
            <p className="text-blue-100 leading-relaxed">
              The hydrophobic properties make water bead and roll off the surface, taking dirt and contaminants with it. 
              This makes your vehicle easier to clean and maintain while looking stunning.
            </p>
          </div>

          <div className="bg-zinc-900 rounded-3xl p-8">
            <h2 className="text-3xl font-bold text-white mb-6">Benefits</h2>
            <ul className="space-y-3">
              {[
                'Long-lasting protection (2-5+ years)',
                'Hydrophobic surface repels water',
                'UV protection prevents fading',
                'Chemical resistance',
                'Enhanced gloss and depth',
                'Easier to clean and maintain',
                'Scratch resistance',
                'Protection from environmental contaminants'
              ].map((benefit, idx) => (
                <li key={idx} className="flex items-start space-x-2">
                  <span className="text-amber-500 mt-1">✓</span>
                  <span className="text-gray-300">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="bg-zinc-900 rounded-3xl p-8 md:p-12 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">Pricing</h2>
          <p className="text-2xl text-gray-300 mb-6">
            Ceramic coating pricing varies based on vehicle size, condition, and preparation requirements.
          </p>
          <p className="text-xl text-amber-500 font-bold mb-8">
            Contact us for a personalized quotation
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-block bg-amber-500 hover:bg-amber-600 text-zinc-900 font-bold px-8 py-4 rounded-lg transition-colors text-lg"
            >
              Contact Us
            </a>
            <a
              href="tel:0896536680"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors text-lg"
            >
              Call: 089 653 6680
            </a>
          </div>
        </div>

        <div className="bg-zinc-900 rounded-3xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold text-white mb-6 text-center">The Application Process</h2>
          <div className="grid md:grid-cols-4 gap-6">
            {[
              { step: '1', title: 'Preparation', desc: 'Paint correction to ensure perfect surface' },
              { step: '2', title: 'Application', desc: 'Precise ceramic coating application' },
              { step: '3', title: 'Curing', desc: 'Proper curing time for optimal bonding' },
              { step: '4', title: 'Inspection', desc: 'Final quality check and delivery' }
            ].map((process) => (
              <div key={process.step} className="text-center">
                <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-2xl text-zinc-900">
                  {process.step}
                </div>
                <h3 className="text-white font-bold mb-2">{process.title}</h3>
                <p className="text-gray-400 text-sm">{process.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-8 md:p-12 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Ready to Protect Your Investment?</h2>
          <p className="text-blue-100 text-lg mb-6">
            Contact us today to schedule your ceramic coating application
          </p>
          <a
            href="/contact"
            className="inline-block bg-amber-500 hover:bg-amber-600 text-zinc-900 font-bold px-8 py-3 rounded-lg transition-colors"
          >
            Get Started
          </a>
        </div>
      </div>

      {/* WhatsApp CTA */}
      <WhatsAppCTA />
    </div>
  );
};

export default CeramicCoating;